import { z } from 'zod'

export const Id = z.uuid()
export const Timestamp = z.iso.datetime({ offset: true })

export const IdParams = z.object({ id: Id })
export type IdParams = z.infer<typeof IdParams>

export const Ok = z.object({ ok: z.literal(true) })
